<div class="card-base">
    <div class="card-content-reservation-search">
        <div class="chip-container">
            <mat-chip-list>
                <mat-chip color="accent" matTooltip="{{ filt.toolTip }}" selected *ngFor="let filt of searchFilters">
                    {{ filt.valueView }}
                    <mat-icon *ngIf="!filt.isRequired" (click)="filt.remove()">cancel</mat-icon>
                </mat-chip>
            </mat-chip-list>
        </div>
        <div class="card-container mat-elevation-z1">
            <div class="clearfix">
                <div class="pull-left div-header-left">
                    <app-search-filter-component #searchFilter (startSearch)="onStartSearch()" (endSearch)="onEndSearch($event)" [filter]="filters"></app-search-filter-component>
                    <app-admission-filter-component #filters></app-admission-filter-component>
                </div>
                <div class="pull-right div-header-right">
                    <mat-spinner *ngIf="loadingMasiveAction" diameter="50"> </mat-spinner>

                    <button class="card-inline margin-top-medium" [matMenuTriggerFor]="columnsMenu" type="button" mat-mini-fab matTooltip="Columnas visibles">
            <mat-icon>view_column</mat-icon>
          </button>


                    <button *ngIf="!loadingMasiveAction" class="card-inline margin-top-medium" [matMenuTriggerFor]="massiveMenu" type="button" mat-mini-fab matTooltip="Acciones masivas">
            <mat-icon>more_vert</mat-icon>
          </button>
                    <mat-spinner [diameter]="50" *ngIf="loadingAction"></mat-spinner>
                    <mat-menu #massiveMenu="matMenu">
                        <button (click)="controled()" mat-menu-item>
              <span><b>Controlado</b></span>
            </button>
                        <button (click)="rollBackControled()" mat-menu-item>
              <span><b>Revertir control</b></span>
            </button>
                    </mat-menu>


                    <mat-menu #columnsMenu="matMenu" class="columns-menu">
                        <button mat-menu-item (click)="showAllColumns()">
              <span>Mostrar todas</span>
            </button>
                        <mat-divider></mat-divider>
                        <div class="columns-menu-item" *ngFor="let col of availableColumns" (click)="$event.stopPropagation()">
                            <mat-checkbox [checked]="isColumnVisible(col.field)" (click)="$event.stopPropagation()" (change)="setColumnVisibility(col.field, $event.checked)">
                                {{ col.title }}
                            </mat-checkbox>
                        </div>
                    </mat-menu>
                </div>
            </div>
            <mat-divider></mat-divider>

            <div class="card-content margin-botton-medium">
                <div class="grid-scroll-container" #gridScrollContainer>
                    <p-table class="search-table" [value]="dataSource" [tableStyle]="{ width: '100%', 'table-layout': 'fixed' }">
                        <ng-template pTemplate="header">
                            <tr class="search-table-header">
                                <th class="checkbox-column">
                                    <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()" [indeterminate]="selection.hasValue() && !isAllSelected()"></mat-checkbox>
                                </th>
                                <th class="resizable-header" *ngFor="let col of orderedColumnsDefinition" [style.width.px]="getColumnWidth(col.field)" (dragover)="onHeaderDragOver($event)" (drop)="onHeaderDrop($event, col.field)">
                                    <div class="header-top-row">
                                        <span class="header-drag-content">
                      <span
                        class="column-title"
                        (click)="sortByColumn(col.field)"
                      >
                        {{ col.title }}
                        <mat-icon class="sort-icon">{{
                          getSortIcon(col.field)
                        }}</mat-icon>
                      </span>
                                        <mat-icon class="header-drag-handle" draggable="true" (dragstart)="onHeaderDragStart($event, col.field)" (dragend)="onHeaderDragEnd()" (click)="$event.stopPropagation()">drag_indicator</mat-icon>
                                        </span>
                                        <span class="column-resize-handle" (mousedown)="startResize($event, col.field)"></span>
                                    </div>
                                    <input class="column-filter-input" [value]="columnFilters[col.field] || ''" (click)="$event.stopPropagation()" (input)="
                      onColumnFilterInput(col.field, $event.target.value)
                    " placeholder="Filtrar" />
                                </th>
                                <th class="actions-column"></th>
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="body" let-element>
                            <tr class="search-table-cell" (click)="admissionEdit(element)">
                                <td class="checkbox-column">
                                    <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(element) : null" [checked]="selection.isSelected(element)"></mat-checkbox>
                                </td>
                                <td *ngFor="let col of orderedColumnsDefinition" [style.width.px]="getColumnWidth(col.field)">
                                    <ng-container [ngSwitch]="col.field">
                                        <span *ngSwitchCase="'date'"><b>{{
                        element.DateTime | date: "dd/MM/yyyy HH:mm"
                      }}</b></span
                    >
                    <span *ngSwitchCase="'receptionDate'">{{
                      element.ReceptionDate | date: "dd/MM/yyyy HH:mm"
                    }}</span>
                                        <span *ngSwitchCase="'stateName'">{{
                      element.StateName
                    }}</span>
                                        <span *ngSwitchCase="'isOverAppointment'">{{
                      element.IsOverAppointment ? "Sí" : "No"
                    }}</span>
                                        <span *ngSwitchCase="'isReAppointmentYesNo'">{{
                      element.IsReAppointment ? "Sí" : "No"
                    }}</span>
                                        <span *ngSwitchCase="'patientLasNameFirstName'">{{
                      element.PatientLastNameFirstName
                    }}</span>
                                        <span *ngSwitchCase="'protocol'">{{
                      element.Protocol
                    }}</span>
                                        <span *ngSwitchCase="'practiceRegionName'">{{
                      element.PracticeRegionName
                    }}</span>
                                        <span *ngSwitchCase="'equipmentName'">{{
                      element.EquipmentName
                    }}</span>
                                        <span *ngSwitchCase="'physicianLastNameFirstName'">{{
                      element.PhysicianLastNameFirstName
                    }}</span>
                                        <span *ngSwitchCase="'entityName'">{{
                      element.EntityName
                    }}</span>
                                    </ng-container>
                                </td>
                                <td class="actions-column" (click)="$event.stopPropagation()">
                                    <button mat-icon-button [matMenuTriggerFor]="menuItem" (click)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                                    <mat-menu #menuItem="matMenu">
                                        <button mat-menu-item (click)="admissionEdit(element)">
                      <mat-icon>edit</mat-icon><span>Editar</span>
                    </button>
                                        <button mat-menu-item *ngIf="canChangeAppointmentDate" (click)="changeAppointmentDate(element)">
                      <mat-icon>edit</mat-icon
                      ><span>Cambiar fecha recepción</span>
                    </button>
                                        <button mat-menu-item (click)="admissionView(element)">
                      <mat-icon>search</mat-icon><span>Ver</span>
                    </button>
                                        <button mat-menu-item (click)="openLogViewDialog(element)">
                      <mat-icon>search</mat-icon><span>Ver actividades</span>
                    </button>
                                        <button mat-menu-item (click)="openMedicalAppointmentObservationDialog(element)">
                      <mat-icon>search</mat-icon><span>Observaciones</span>
                    </button>
                                        <button *ngIf="element.IsReAppointment" mat-menu-item (click)="assignMedicalAppointment(element)">
                      <mat-icon>edit</mat-icon><span>Asignar turno</span>
                    </button>
                                        <button mat-menu-item *ngIf="canCancelAdmited" (click)="openMedicalAppointmentCancelDialog(element)">
                      <mat-icon>cancel</mat-icon><span>Cancelar</span>
                    </button>
                                    </mat-menu>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
                <pager (selectedPageIndexChange)="selectedPageIndexChange($event)" #pager></pager>
            </div>
        </div>
    </div>
</div>
